import * as React from 'react';
import { useEffect, useState, useRef } from "react";
import useClickAway from "../../js/helpers/useClickAway.ts";
import type { MenuData } from "../../js/data/menuData.ts";
import useWindowScrollRaf from "../../js/helpers/useWindowScrollRaf.ts";
import Logo from "./logo.tsx";
import MenuItem, { filterMenuItemsByParent } from "./menuItem.tsx";
import clsx from 'clsx';

type Props = Readonly<{
	menu: MenuData,
	pathname: string,
}>

function Header({menu, pathname, ...otherProps}: Props) {
	const refHeader = useRef<HTMLHeadingElement>(null);
	const refMobileMenu = useRef<HTMLDivElement>(null);
	const [opened, setOpened] = useState<boolean>(false);

	const { x, y } = useWindowScrollRaf();
	const [isSticky, setIsSticky] = useState<boolean>(false);

	if (isSticky === false && y > 10) {
		setIsSticky(true);
	}
	if (isSticky === true && y == 0) {
		setIsSticky(false);
	}

	useClickAway(refMobileMenu, () => setOpened(false));

	useEffect(() => {
		setOpened(false);
	}, [pathname]);

	let logo = <><Logo className={clsx("mx-0 transition-all ease-mine", isSticky ? 'my-3 small' : 'my-6')}/></>;

	if (pathname === '/') {
		logo = <span className="inline-block">{logo}</span>;
	} else {
		logo = <a href="/" className="inline-block no-underline hover:text-grey-500">{logo}</a>;
	}

	const rootMenuItems = filterMenuItemsByParent(menu, null);

	return (<>
		{/*<Dump {...menu}/>*/}
		{/*<div className="fixed top-0 left-0 z-50">*/}
		{/*	<Dump value={y}/>*/}
		{/*</div>*/}

		<div
			id="headerWrapper"
			className={clsx(
				"-top-[1px] fixed z-10 w-full text-white transition-all ease-mine",
				isSticky ? "bg-black/70" : 'bg-black/0'
			)}
			{...otherProps}
			ref={refHeader}
		>
			<header className={clsx(
				"max-w-screen-2xl mx-auto text-center @apply px-8 md:px-20 xl:px-30 transition-all ease-mine duration-500",
				isSticky ? "py-0" : 'py-0'
			)}>
				<div className={clsx("flex flex-wrap items-center justify-between gap-x-4")}>
					<a href="#mobileMenu"
					   className={clsx("iconHamburger white", opened && "iconHamburgerOpened")}
					   aria-label="Menu"
					   title="Menu"
					   onClick={() => setOpened((opened) => {
						   return !opened;
					   })}
					>
						<span/>
						<span/>
						<span/>
					</a>

					{logo}

					<a href="/contact" className="no-underline hover:underline text-sm">
						Let’s Talk
					</a>
				</div>
			</header>
		</div>

		<div className={clsx(
			"fixed top-0 right-0 z-80 h-full w-full transition-all duration-300",
			opened ? 'bg-black/50 visible backdrop-blur-sm' : 'backdrop-blur-none bg-secondary-300/0 invisible'
		)}/>

		<div id="mobileMenu" className={clsx(
			"fixed top-0 left-0 z-90 h-full w-full overflow-y-auto overscroll-y-none transition duration-500",
			opened ? 'translate-x-0' : '-translate-x-full'
		)}>
			<div className="float-left relative w-3/4 md:w-1/2 xl:w-1/3 2xl:w-1/4 bg-white text-black shadow-xl rounded-br-3xl p-8 sm:py-12 md:px-24" ref={refMobileMenu}>
				<a
					href="#x"
					className="iconOpenClose iconOpened absolute top-7 right-8 sm:right-12"
					onClick={(event) => {
						event.preventDefault();
						setOpened(false);
					}}
					title="X"
				/>
				{/*<div className="pb-4 mb-8 border-b border-white">*/}
				{/*	<div className="inline-block">*/}
				{/*		<div className="logo small"/>*/}
				{/*	</div>*/}
				{/*</div>*/}

				<menu className="mobileMenu">
					{rootMenuItems?.map((item, index) => {
						return <MenuItem
							menu={menu}
							item={item}
							key={'item' + index}
							pathname={pathname}
							index={index}
							siblingsCount={rootMenuItems.length - 1}
						/>;
					})}
				</menu>
				<a href="https://r2.dscore.com/#/invite?lr=uDq3V9xkZQ5S5oGGm4mrt-g%3D%3D" className="px-8 mt-4 inline-block no-underline hover:no-underline">
					Submit a Case<br/><img src="/images/header/submit.png" alt="" width="72" height="40"/>
				</a>
			</div>
		</div>
	</>);
}

export default Header;
